import React from "react";
import { createRoot } from "react-dom/client";
import type { DataUploadPropTypes } from "@/react/prop-types";
import { DataUpload } from "./components/data-upload/data-upload";
import { ToastAlertProvider } from "@procore/toast-alert";
import { FeatureToggleProvider } from "@procore/web-sdk-feature-toggle";
import { authManager } from "@/lib/managers/auth-manager";
import EnvironmentI18n from "./providers/EnvironmentI18n";

export default (props: DataUploadPropTypes) => {
   const container = document.getElementById("data-upload-react-mount");
   const root = createRoot(container!);
   // istanbul ignore next
   const user = authManager.authedUser();
   const locale = (window.I18n?.locale as any) ?? "en";

   root.render(
      <EnvironmentI18n locale={locale}>
         <FeatureToggleProvider
            apiKey={(window as any).config.LC_LD_CLIENT_SIDE_ID}
            context={{
               kind: "multi",
               email: {
                  kind: "email",
                  // istanbul ignore next
                  key: user?.email(),
               },
               company_id: {
                  kind: "company_id",
                  // istanbul ignore next
                  key: user?.companyId(),
               },
               user: {
                  // istanbul ignore next
                  email: user?.email() ?? "unknown",
               },
            }}
         >
            <ToastAlertProvider>
               <DataUpload {...props} />
            </ToastAlertProvider>
         </FeatureToggleProvider>
      </EnvironmentI18n>,
   );
};
